export interface Division {
  title: string;
  value: DivisionName;
}

export type Divisions = Array<Division>;

type BattleTypeToDivisionsMap = {
  [key: string]: Divisions;
};

export const getDivisionsFromBattletype = (
  battleType: BattleTypeNameWithDivisions,
  t: (str: string) => string,
): Divisions => {
  const BattleTypeToDivisionsMap: BattleTypeToDivisionsMap = {
    ['pvp']: [
      {
        title: t('All'),
        value: '',
      },
      {
        title: t('Alone'),
        value: 'solo',
      },
      {
        title: t('In a Division of two'),
        value: 'div2',
      },
      {
        title: t('In a Division of three'),
        value: 'div3',
      },
    ],
    ['rank']: [
      {
        title: t('Alone'),
        value: 'solo',
      },
      {
        title: t('In a Division of two'),
        value: 'div2',
      },
      {
        title: t('In a Division of three'),
        value: 'div3',
      },
    ],
    ['rank_old']: [
      {
        title: t('Alone'),
        value: 'solo',
      },
    ],
  };
  return BattleTypeToDivisionsMap[battleType] || [];
};
